import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Daily from '@/pages/Daily';

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/helpers/store'

import VueI18n from 'vue-i18n'
import dictionary from '@/plugins/i18n'
const i18n = new VueI18n(dictionary)

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Home,
        meta: {}
    },
    {
        path: '/privacy',
        component: () => import('@/pages/Privacy'),
        meta: {}
    },
    {
        path: "/login",
        component: Login,
        meta: {}
    },
    {
        path: '*', component: Home
    },
    {
        path: '/my-information',
        component: () => import('@/pages/MyInformation'),
        meta: {
            role: 'USER',
        }
    },
    {
        path: '/recovery/:token',
        component: () => import('@/pages/Recovery'),
        meta: {}
    },
    {
        path: "/recovery",
        component: () => import('@/pages/Recovery'),
        meta: {}
    },
    {
        path: '/daily',
        component: Daily,
        meta: {
            role: 'USER',
            menu: {
                title: i18n.t('Atividades diárias'),
                icon: 'push_pin',
            },
        }
    },
    {
        path: '/board',
        component: () => import('@/pages/Board'),
        meta: {
            role: 'OPERATION',
            menu: {
                title: i18n.t('Placas'),
                icon: 'memory',
            },
        }
    },
    {
        path: '/factories',
        component: () => import('@/pages/Factory'),
        meta: {
            role: 'ADMIN',
            menu: {
                title: i18n.t('Fábricas'),
                icon: 'factory',
            },
        }
    },
    {
        path: '/departments',
        component: () => import('@/pages/Department'),
        meta: {
            role: 'ADMIN',
            menu: {
                title: i18n.t('Departamentos'),
                icon: 'groups',
            },
        }
    },
    {
        path: '/users',
        component: () => import('@/pages/User'),
        meta: {
            role: 'ADMIN',
            menu: {
                title: i18n.t('Usuários'),
                icon: 'people',
            },
        }
    },
];

const router = new VueRouter({
    routes,
    mode: 'history'
});

router.beforeEach((routeTo, routeFrom, next) => {
    store.commit("FIRST_REQUEST", true);

    if (routeTo.path == "/login") {
        store.state.routeBeforeLogin = routeFrom.path;
    }

    // Enter here if route has a role to access
    if (routeTo.meta && routeTo.meta.role) {
        try {
            // If user not logged or not contains permission, send to home page
            if (store.getters.verifyRole(routeTo.meta.role) == false) {
                return next({ path: routeTo.meta.redirectToWhenNotPermit ? routeTo.meta.redirectToWhenNotPermit : "/" });
            }
        } catch (e) {
            return next({ path: "/" });
        }
    }
    next()
})

export default router